import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
import { SmartLink } from '../SmartLink';
import { MockCardView } from '../product/mock/MockCardView';
import type { MockCard } from '../../types/product';
import type { SolutionSummary } from '../../types/solution';
type SolutionHeroProps = {
  summary: SolutionSummary;
  headline: string;
  subheadline: string;
  card: MockCard;
};
export function SolutionHero({
  summary,
  headline,
  subheadline,
  card
}: SolutionHeroProps) {
  const Icon = summary.icon;
  return <section className="hero-surface w-full overflow-hidden" aria-labelledby="solution-hero-heading" data-id="element-1568" data-mp="1zn6d0s677xda">
      <div className="mx-auto max-w-shell px-6 pb-16 pt-6 lg:pb-24" data-id="element-1569" data-mp="1lugnwevdicby">
        <nav aria-label="Breadcrumb" data-id="element-1570" data-mp="1pwv5kvnb361n">
          <ol className="flex items-center gap-1.5 text-[13px] text-ink-muted" data-id="element-1571" data-mp="1pvsfur1pz9nb">
            <li data-id="element-1572" data-mp="2dmfo5dfjs1ae">
              <SmartLink href="/" className="transition-colors duration-150 ease-out hover:text-ink" data-id="element-1573" data-mp="2dlw8k3dddozj">
                Solutions
              </SmartLink>
            </li>
            <li aria-hidden="true" data-id="element-1574" data-mp="1xe8v6cecnzt6">
              <ChevronRightIcon className="h-3.5 w-3.5" data-id="element-1575" data-mp="1xfbikacgrk4c" />
            </li>
            <li aria-current="page" className="font-medium text-ink" data-id="element-1576" data-mp="1sggtwrrtf1cb">
              {summary.title}
            </li>
          </ol>
        </nav>

        <div className="mt-10 grid grid-cols-1 items-center gap-12 lg:mt-14 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.1fr)] lg:gap-14" data-id="element-1577" data-mp="276odjatk6qel">
          <div className="max-w-[540px]" data-id="element-1578" data-mp="2g502l8es1g4x">
            <p className="inline-flex items-center gap-2 text-[14px] font-semibold text-ink" data-id="element-1579" data-mp="2g3ouiweatm80">
              <span className="flex h-7 w-7 items-center justify-center rounded-[8px] border border-canvas-line bg-white text-brand" data-id="element-1580" data-mp="2c2woec0q3xfy">
                <Icon className="h-4 w-4" strokeWidth={1.9} aria-hidden="true" data-id="element-1581" data-mp="2q13ayw082b0b" />
              </span>
              {summary.title}
            </p>
            <h1 id="solution-hero-heading" className="display mt-5 text-[38px] font-semibold text-ink sm:text-[50px] lg:text-[56px]" data-id="element-1582" data-mp="vqhk6tzxhws5">
              {headline}
            </h1>
            <p className="mt-6 max-w-[480px] text-[18px] leading-[1.5] text-ink-muted" data-id="element-1583" data-mp="2qu5ssevvl9l2">{subheadline}</p>
            <div className="mt-9 flex flex-wrap items-center gap-3" data-id="element-1584" data-mp="2vs7llrj3sn9q">
              <SmartLink href="/get-started" className="rounded-[7px] bg-brand px-5 py-3 text-[15px] font-semibold text-white transition-colors duration-150 ease-out hover:bg-brand-hover" data-id="element-1585" data-mp="2zszv8lvw0u6j">
                Get started
              </SmartLink>
              <SmartLink href="/demo" className="rounded-[7px] border border-ink/20 bg-white px-5 py-3 text-[15px] font-semibold text-ink transition-colors duration-150 ease-out hover:border-ink/45" data-id="element-1586" data-mp="3eq0c1ucjj4q8">
                Book a demo
              </SmartLink>
            </div>
          </div>

          <div className="relative pb-24 sm:pb-12 lg:pb-14" data-id="element-1587" data-mp="3sjhxjkoseriw">
            <img src={summary.image} alt={summary.alt} className="h-[320px] w-full rounded-[16px] object-cover sm:h-[440px] lg:h-[520px]" data-id="element-1588" data-mp="1b44x02z7pkq" />
            <div className="absolute bottom-0 left-4 right-4 sm:left-auto sm:right-[-16px] sm:w-[320px] lg:right-[-32px]" data-id="element-1589" data-mp="6fy57dd5neck">
              <div className="shadow-[0_28px_56px_-24px_rgba(11,11,11,0.45)] rounded-[14px]" data-id="element-1590" data-mp="1ifrl9o70ay8">
                <MockCardView card={card} data-id="element-1591" data-mp="3tm8mrag7ldpz" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}